import React from "react";
import { useParams } from "react-router-dom";
import Main from "./Main";
import { makeCompanyNav } from "./nav";
import ActivityFeed from "./components/ActivityFeed";

export default function Activity() {
  const { company } = useParams();
  return (
    <Main navItems={makeCompanyNav(company)}>
      <div className="wt-page">
        <h1 className="wt-page__title">Aktivitet</h1>
        <p className="wt-page__subtitle">
          Allt som händer i workspacet — uppladdningar, signaturer, värderingar,
          köparflöde. Buyers ser bara sina egna händelser.
        </p>
        <ActivityFeed
          workspaceKey={company}
          variant="full"
          limit={200}
          title="Senaste händelser"
          pollMs={30000}
        />
      </div>
    </Main>
  );
}
